﻿import * as React from 'react';
import { RENDERABLE_ELEMENTS } from '../../../../common/constants';
import { camelCaseToKebabCase } from '../../../../common/pdUtils';
import SvgEditService from '../../../../services/svg-edit-service';
import { BaseResolver } from './base-resolver';

interface ResolverState {
}

export class Resolver_StyleToAttribute extends BaseResolver {
    public id: "resolver_styletoattribute";

    public needResolution(): boolean {
        return true;
    }

    public resolveSvg(svgContainer: HTMLTemplateElement) {
        this.resolveElement(svgContainer.firstElementChild as SVGSVGElement);
    }

    private resolveElement(el: SVGGraphicsElement) {
        if (RENDERABLE_ELEMENTS.includes(el.tagName.toLowerCase())) {
            this.setAttribIfNeeded(el, "fill");
            this.setAttribIfNeeded(el, "fillOpacity");
            this.setAttribIfNeeded(el, "fillRule");
            this.setAttribIfNeeded(el, "clipRule");

            this.setAttribIfNeeded(el, "stroke");
            this.setAttribIfNeeded(el, "strokeOpacity");
            this.setAttribIfNeeded(el, "strokeWidth");
            this.setAttribIfNeeded(el, "strokeDasharray");
            this.setAttribIfNeeded(el, "strokeDashoffset");
            this.setAttribIfNeeded(el, "strokeLinecap");
            this.setAttribIfNeeded(el, "strokeLinejoin");
            this.setAttribIfNeeded(el, "strokeMiterlimit");

            this.setAttribIfNeeded(el, "fontFamily");
            this.setAttribIfNeeded(el, "fontSize");
        }

        if (!el.hasAttribute("id")) {
            el.setAttribute("id", `ELEMENT_${SvgEditService.GetNextElementID()}`);
        }

         // We don't support classes right now, and they only cause problems with the rest of the UI.
        if (el.hasAttribute("class")) {
            el.removeAttribute("class");
        }

        for (const child of el.children) {
            this.resolveElement(child as SVGGraphicsElement);
        }
    }

    private setAttribIfNeeded(el: SVGGraphicsElement, attr: string) {
        if (el.style[attr] && el.style[attr].length > 0) {
            el.setAttribute(camelCaseToKebabCase(attr), el.style[attr]);
            el.style[attr] = null;
        }
    }
}

